module.exports = __webpack_public_path__ + "static/media/3.631c7524.jpg";